import React from 'react';
import { Button, Typography } from 'antd';
import { Link } from 'react-router-dom';
import './WelcomePage.css';

const { Title, Paragraph } = Typography;

const WelcomePage: React.FC = () => {
  return (
    <div className="auth-container" style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="auth-wrapper">
        <div className="auth-card" style={{ textAlign: 'center' }}>
          <div className="auth-header">
            <div className="brand-logo">
              <img src="/auth/logo.svg" alt="Logo" style={{ width: '80px', marginBottom: '20px' }} />
            </div>
            <Title level={2} className="auth-title">欢迎使用以图搜图系统</Title>
            <Paragraph className="auth-subtitle" style={{ marginBottom: '30px' }}>
              高效、精准的图像搜索引擎，助您快速发现相似图片。
            </Paragraph>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
            <Link to="/login">
              <Button type="primary" size="large" style={{ minWidth: '120px' }}>
                登录
              </Button>
            </Link>
            <Link to="/register">
              <Button size="large" style={{ minWidth: '120px' }}>
                注册
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomePage;
